module.exports = __webpack_public_path__ + "img/258.09b9f266.png";